export default class ToolBaseManager {
  constructor() {
    this.tools = {};
  }

  registerTool(name, toolInstance) {
    if (!name || typeof name !== "string") {
      throw new Error("Имя плагина должно быть строкой.");
    }
    if (!toolInstance || typeof toolInstance !== "object") {
      throw new Error("Плагин должен быть объектом или классом.");
    }

    this.tools[name] = toolInstance;
    // Создание доступа к плагину через менеджер
    Object.defineProperty(this, name, {
      get: () => this.tools[name],
      enumerable: true,
      configurable: true,
    });
  }
}
